import {
  AlertInfoIcon,
  AlertCriticalIcon,
  AlertIcon,
  CanceledStatusIcon,
} from '@fortress-technology-solutions/fortress-component-library/Icons';

import { ALT_ANNUAL_INCOME_NAME } from './common';

export const lowercaseFirstLetter = (string) => {
  return `${string.charAt(0).toLowerCase()}${string.substr(1, string.length)}`;
};

export const determineFieldName = (link) => {
  const index = link?.index ?? null;
  const hasIndex = index || index === 0;
  if (hasIndex && link.keyName) {
    return `${link.name}[${index}].${link.keyName}`;
  }
  return link.name;
};

export const generateOnBlurAnnualIncomeCalculation = ({
  fieldName,
  otherField,
}) => {
  const annualIncomeKey = ALT_ANNUAL_INCOME_NAME;
  return (val, linkedState, link) => {
    const idx = link.index ?? null;
    const hasIndex = idx || idx === 0;
    const otherFieldVal = hasIndex
      ? linkedState[`${fieldName}[${idx}].${otherField}`]
      : linkedState[`${fieldName}${otherField}`];
    const parsedOtherField = parseFloat(otherFieldVal);
    const parsedBlurField = parseFloat(val);

    const calculatedAnnualIncome =
      isNaN(parsedOtherField) || isNaN(parsedBlurField)
        ? '0.00'
        : ((parsedOtherField * parsedBlurField) / 100).toFixed(2);
    const incomeKey = hasIndex
      ? `${fieldName}[${idx}].${lowercaseFirstLetter(annualIncomeKey)}`
      : `${fieldName}${annualIncomeKey}`;
    return [val, incomeKey, calculatedAnnualIncome];
  };
};

export const getTooltipIcon = (type) => {
  let tooltipIcon;
  switch (type) {
    case 'INFO':
      tooltipIcon = <AlertInfoIcon />;
      break;
    case 'WARNING':
      tooltipIcon = <AlertIcon />;
      break;
    case 'CRITICAL':
      tooltipIcon = <AlertCriticalIcon />;
      break;
    case 'ERROR':
      tooltipIcon = <CanceledStatusIcon />;
      break;
    default:
      tooltipIcon = <AlertInfoIcon />;
      break;
  }

  return tooltipIcon;
};
